import React from 'react';
import styled from 'styled-components';
//
import Loading from 'svg/loading';
//
export default () => (
  <Wrap>
    <Loading />
  </Wrap>
);
//
const Wrap = styled.div`
  margin: 4rem auto 80vh;
  width: 4rem;
`;
